export const environment = {
    "aws": {
        "Auth": {
            "authenticationFlowType": "USER_PASSWORD_AUTH",
            "cookieStorage": {
                "domain": ".examsoft.com",
                "expires": 365,
                "path": "/",
                "secure": true
            },
            "identityPoolId": "us-west-2:2c8cd130-d4b5-4308-9810-d0cc196aa196",
            "identityPoolRegion": "us-west-2",
            "region": "us-west-2",
            "userPoolId": "us-west-2_cROlf0oJL",
            "userPoolWebClientId": "44smfvm0841fcjb1idd5vl3f34"
        },
        "aws_appsync_authenticationType": "AWS_IAM",
        "aws_appsync_graphqlEndpoint": "https://kp5q5slvwvbbfpnyxefqohypke.appsync-api.us-west-2.amazonaws.com/graphql",
        "aws_appsync_region": "us-west-2",
        "oauth": {
            "domain": "cog004usorprod.auth.us-west-2.amazoncognito.com",
            "options": {
                "AdvancedSecurityDataCollectionFlag": true
            },
            "redirectSignIn": "https://examnow.examsoft.com",
            "redirectSignOut": "https://examnow.examsoft.com",
            "responseType": "code",
            "scope": [
                "phone",
                "email",
                "profile",
                "openid",
                "aws.cognito.signin.user.admin"
            ]
        }
    },
    "esLogin": "https://login.examsoft.com/",
    "metadata": {
        "application_code": "Xnw",
        "geographic_code": "us",
        "instance_index": "004"
    },
    "production": true,
    "urls": {
        "gatewayApiUrl": "https://b3nzhqaptd.execute-api.us-west-2.amazonaws.com/examnow-prod",
        "institutionApiUrl": "https://cog004-api-prod.examsoft.com/institutions",
        "pltApiUrl": "https://plt004-api-prod.examsoft.com",
        "pltUrl": "https://plt004-ui-prod.examsoft.com"
    }
};